import {
  PARTIAL_CREDIT_ACCEPTED,
  PARTIAL_CREDIT_CLOSED_BEFORE_REPLY,
  PARTIAL_CREDIT_DENIED,
  REQUESTED,
  PARTIAL_CREDIT_STATUSES
} from "MODULES/RMAsAndWarranties/constants";

export const getPartialCreditOptions = partialCreditStatus =>
  [REQUESTED, PARTIAL_CREDIT_ACCEPTED, PARTIAL_CREDIT_DENIED]
    .concat(
      partialCreditStatus === PARTIAL_CREDIT_CLOSED_BEFORE_REPLY
        ? [PARTIAL_CREDIT_CLOSED_BEFORE_REPLY]
        : []
    )
    .map(value => ({
      text: PARTIAL_CREDIT_STATUSES[value],
      value
    }));



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/CustomerRmaCreditSection/helpers.js